export enum RecurringPaymentStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Paused = 'PAUSED',
  Errored = 'ERRORED'
}

export const PRETTY_RECURRING_PAYMENT_STATUS = {
  [RecurringPaymentStatus.Active]: 'Active',
  [RecurringPaymentStatus.Ended]: 'Ended',
  [RecurringPaymentStatus.Paused]: 'Paused',
  [RecurringPaymentStatus.Errored]: 'Errored'
}
